import React from 'react';
import styled from 'styled-components';

const HeaderWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 40px;

	@media ${props => props.theme.device.smTablet} {
		margin-bottom: 28px;
	}
	@media ${props => props.theme.device.mobile} {
		margin-bottom: 28px;
	}
`;

const DecoratorLine = styled.span`
	flex: 1 1 auto;
	height: 1px;
	background: ${props => props.background};
`;

const LeftLine = styled(DecoratorLine)`
	background: linear-gradient(
		90deg,
		rgba(88, 124, 176, 0) 0%,
		${props => props.theme.colors.primary || '#587CB0'} 100.58%
	);
`;

const RightLine = styled(DecoratorLine)`
	background: linear-gradient(
		90deg,
		${props => props.theme.colors.primary || '#587CB0'} 0%,
		rgba(88, 124, 176, 0) 100.58%
	);
`;

const Text = styled.div`
	display: flex;
	justify-content: center;
	font-size: 24px;
	width: 282px;
	color: #333;

	@media ${props => props.theme.device.smTablet} {
		width: 200px;
		font-size: 20px;
	}

	@media ${props => props.theme.device.mobile} {
		width: 200px;
		font-size: 20px;
	}
`;

interface IHeader {
	text: string;
}

const Header = ({ text }: IHeader): JSX.Element => (
	<HeaderWrapper>
		<LeftLine />
		<Text>{text}</Text>
		<RightLine />
	</HeaderWrapper>
);

export default Header;
